import { FacetType } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
export { FacetType } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

export { FacetGroupHeader } from './facet-header'
export { FacetGroupMultiple } from './facet-multiple'
export { FacetGroupRange } from './facet-range'
export { FilterBox } from './filter-box'
export { Filters } from './filters'

export const BOOLEAN_FACET_NAME = 'showonly'

export type FacetGroup = {
  name: string
  displayName: string
  displayEnglishName: string
  unitText: string
  nameInUrl: string
  type: FacetType
  facetOpened: boolean
  isTranslated: boolean
  values: {
    displayName?: string | null
    name: string
    hits: number
    min?: number | null
    max?: number | null
  }[]
}
